// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Img from "@insite/mobius/Img";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ImgProps } from "@steiner/MobiusOverrides/Img/Img";
import React, { useContext } from "react";

export interface OrderPodSignatureStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyPresentationProps;
    img?: ImgProps;
}

export const orderPodSignatureStyles: OrderPodSignatureStyles = {};

const styles = orderPodSignatureStyles;

const OrderDetailsPodSignature = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.properties || !order.properties.orderBase64Img) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderDetailsPodSignature">
                {translate("Proof of Delivery Signature image")}
            </Typography>
            <Img {...styles.img} src={`data:image/png;base64,${order.properties.orderBase64Img}`} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsPodSignature,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
